<template>
  <div class="container-xxl my-3">

    <div class="search-input-wrap d-flex justify-content-end mb-1">
      <div class="input-group">
        <input
          type="text"
          class="form-control search-users"
          placeholder="Αναζήτηση..."
          v-model="searchQuery"
          @keyup="searchUsers"
        />

      </div>
    </div>

    <div class="show-roles-wrap d-flex gap-2 justify-content-between mt-3">
      <div class="checkbox-wrap">
          <label for="roles">Λίστα Ελεγκτών</label>
          <input type="checkbox" class="show-roles ms-2" name="roles" @change="toggleRoles">
      </div>
     
      <div v-if="showRoles" class="create-checker-wrap mb-2" >
        <a href="#" class="checker" @click.prevent="openNewCheckerModal">
          Νέος Ελεγκτής
        </a> 
      </div>
    </div>

    <div class="card shadow-sm border-0">
      <div class="card-body"> 
        <h3 v-if="showRoles"class="card-title mb-4 text-primary fw-semibold">Λίστα Ελεγκτών</h3>
        <h3 v-else class="card-title mb-4 text-primary fw-semibold">Λίστα Χρηστών</h3>

        <div class="table-responsive">
          <table class="table table-hover align-middle">
            <thead class="">
              <tr>
                <th>#</th>
                <th>ΌΝΟΜΑ</th>
                <th>ΕΠΙΘΕΤΟ</th>
                <th>EMAIL</th>
                <th>ΤΗΛΕΦΩΝΟ</th>
                <th>ΔΗΜΙΟΥΡΓΗΘΗΚΕ</th>
                <th v-if="showRoles"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in users.data" :key="user.id">
                <td>{{ user.id }}</td>
                <td>{{ user.name }}</td>
                <td>{{ user.surname }}</td>
                <td>{{ user.email }}</td>
                <td>{{ user.mobile }}</td>
                <td>{{ formatDate(user.created_at) }}</td>

               
                <td v-if="showRoles" class="d-flex justify-content-end">
                  <button class="btn shadow-sm bg-white" @click="editUser(user)">
                      <i class="icofont icofont-edit fs-6 text-success"></i>
                  </button>
                  <button class="btn shadow-sm bg-white" @click="deleteChecker(user.id)">
                      <i class="icofont icofont-trash fs-6 text-danger"></i>
                  </button>
                </td>
              </tr>

              <tr v-if="users.data.length === 0">
                <td colspan="6" class="text-center text-muted py-4">
                  No users found.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="d-flex justify-content-between align-items-center mt-4">
          <button class="btn prev-page" :disabled="users.current_page === 1" @click="prevPage">
            <i class="bi bi-arrow-left-circle me-1"></i> Προηγούμενο
          </button>

          <span class="fw-medium">
            Σελίδα {{ users.current_page }} of {{ users.last_page }}
          </span>

          <button class="btn next-page" :disabled="users.current_page === users.last_page" @click="nextPage">
            Επόμενο <i class="bi bi-arrow-right-circle ms-1"></i>
          </button>
        </div>
      </div>
    </div>
  </div>





<!-- Modal -->
<div class="modal fade" id="addCheckerModal" tabindex="-1" aria-labelledby="addCheckerModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="addCheckerModalLabel">Προσθήκη Νέου Ελεγκτή</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="addChecker">
          <div class="mb-3">
            <label for="username" class="form-label">Username</label>
            <input type="text" id="username" class="form-control" v-model="newChecker.username" required>
          </div>
          <div class="mb-3">
            <label for="name" class="form-label">Όνομα</label>
            <input type="text" id="name" class="form-control" v-model="newChecker.name" required>
          </div>
          <div class="mb-3">
            <label for="surname" class="form-label">Επίθετο</label>
            <input type="text" id="surname" class="form-control" v-model="newChecker.surname" required>
          </div>
          <div class="mb-3">
            <label for="email" class="form-label">Email</label>
            <input type="email" id="email" class="form-control" v-model="newChecker.email" required>
          </div>
           <div class="mb-3">
            <label for="mobile" class="form-label">Τηλέφωνο</label>
            <input type="text" id="mobile" class="form-control" v-model="newChecker.mobile">
          </div>
          <div class="mb-3">
            <label for="password" class="form-label">Password</label>
           <input type="password" id="password" class="form-control" v-model="newChecker.password" :required="!isEditing" >
          </div>
          <div class="text-end">
            <button type="button" class="btn btn-secondary me-2" data-bs-dismiss="modal">Ακύρωση</button>
            <button type="submit" class="btn btn-primary">Προσθήκη</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

</template>

<script setup>
import { ref, onMounted } from 'vue';
import { fetchUsers } from '@/services/user';
import { createTicketChecker, updateTicketChecker, deleteTicketChecker } from '@/services/auth';
import { useToast } from 'vue-toastification';

const toast = useToast();
const users = ref({ data: [], current_page: 1, last_page: 1 });
const searchQuery = ref('');
const showRoles = ref(0);
const isEditing = ref(false);
let searchTimeout = null;


const newChecker = ref({
  username: '',
  name: '',
  surname: '',
  email: '',
  mobile: '',
  password: ''
});



const openNewCheckerModal = () => {
  isEditing.value = false;
  newChecker.value = {
    username: '',
    name: '',
    surname: '',
    email: '',
    mobile: '',
    password: ''
  };

  const modal = new bootstrap.Modal(document.getElementById('addCheckerModal'));
  modal.show();
};


const editUser = (user) => {
  isEditing.value = true;

  newChecker.value.id = user.id;
  newChecker.value.username = user.username || '';
  newChecker.value.name = user.name || '';
  newChecker.value.surname = user.surname || '';
  newChecker.value.email = user.email || '';
  newChecker.value.mobile = user.mobile || '';
  newChecker.value.password = ''; 

  const modal = new bootstrap.Modal(document.getElementById('addCheckerModal'));
  modal.show();
};



const addChecker = async () => {
  if (isEditing.value) {
    const payload = { user_id: newChecker.value.id, ...newChecker.value };

    const result = await updateTicketChecker(payload);
    if (result.success) {
        toast('Η επεξεργασία ολοκληρώθηκε με επιτυχία.')
      fetchAllUsers();
    }
  } else {
    const result = await createTicketChecker(newChecker.value);
    if (result.success) {
        toast('Ο Ελεγκτής δημιουργήθηκε με επιτυχία.')
      fetchAllUsers();
    }
  }

  const modalEl = document.getElementById('addCheckerModal');
  const modal = bootstrap.Modal.getInstance(modalEl);
  modal.hide();

  newChecker.value = { username: '', name: '', surname: '', email: '', mobile: '', password: '' };
  isEditing.value = false;
};



const deleteChecker = async(user_id) => {
    const payload = { user_id: user_id};

    const result = await deleteTicketChecker(payload);
    if (result.success) {
      toast('Ο Ελεγκτής διαγράφηκε με επιτυχία.')
      fetchAllUsers();
    } else {
      toast('Κάτι πήγε στραβά. Δοκίμασε ξανά αργότερα.');
    }


}



const fetchAllUsers = async (page = 1) => {
  try {
    const response = await fetchUsers({ page: page, search: searchQuery.value, roles: showRoles.value });
    if (response.data.success) {
      users.value = response.data.data;
    } else {
      toast.error('Failed to fetch users.');
    }
  } catch (error) {
    toast.error('An error occurred while fetching users.');
  }
};

const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  return date.toLocaleString();
};


const toggleRoles = () => {
  showRoles.value = showRoles.value ? 0 : 1;
  fetchAllUsers(1, searchQuery.value, showRoles.value);
}

const searchUsers = () => {
  if (searchTimeout) clearTimeout(searchTimeout);

  searchTimeout = setTimeout(() => {
    fetchAllUsers(1, searchQuery.value, showRoles.value);
  }, 300);
};

const prevPage = () => {
  if (users.value.current_page > 1) {
    fetchAllUsers(users.value.current_page - 1, searchQuery.value, showRoles.value);
  }
};

const nextPage = () => {
  if (users.value.current_page < users.value.last_page) {
    fetchAllUsers(users.value.current_page + 1, searchQuery.value, showRoles.value);
  }
};

onMounted(() => {
  fetchAllUsers();
});

</script>

<style scoped>
  .table th {
    white-space: nowrap;
    font-size: 16px;
    font-weight: 400;
    background: var(--primary-color);
    color:#fff;
  }
  .table td {
    vertical-align: middle;
    font-weight: 500;
  }
  .card-title {
    border-bottom: 2px solid black;
    padding-bottom: 0.5rem;
  }

  .prev-page,
  .next-page{
    border: 1px solid black;
    color:black
  }
  

  .bi-arrow-left-circle::before,
  .bi-arrow-right-circle::before {
    line-height: 1.2;
  }

  .input-group{
    width: 300px;
    border-radius: 8px;
  }

  .search-users{
    border-radius: 8px;
  }

  .checker{
    background-color: var(--primary-color);
    color:#fff;
    font-weight: 500;
    padding: 6px 12px;
    font-size: 14px;
    border-radius: 12px;
  }

  .checkbox-wrap{
    display: flex;
    align-items: center;
  }

  @media (max-width: 576px){
    .input-group{
      width: 230px;
    }
  }



  

</style>
